import React from 'react';
import { Select, Option } from 'carbon-react/esm/components/select';
import {
  DateRangePreset,
  DateRangePresetCustom,
  DateRangePresetDays30,
  DateRangePresetDays7,
  DateRangePresetDays90,
} from '../../../utils/dateHelpers';

interface FilterDateRangePresetsProps {
  onPresetChange: (preset: DateRangePreset) => void;
  selectedPreset: DateRangePreset;
}

const FilterDateRangePresets: React.FC<FilterDateRangePresetsProps> = ({
  onPresetChange,
  selectedPreset,
}) => {
  return (
    <Select
      label="Afficher l'activité pour les"
      value={selectedPreset}
      onChange={(e: { target: { value: string } }) =>
        onPresetChange(e.target.value as DateRangePreset)
      }
    >
      <Option text="7 derniers jours" value={DateRangePresetDays7} />
      <Option text="30 derniers jours" value={DateRangePresetDays30} />
      <Option text="90 derniers jours" value={DateRangePresetDays90} />
      <Option text="Dates personnalisées" value={DateRangePresetCustom} />
    </Select>
  );
};

export default FilterDateRangePresets;
